import React, { FC, useMemo } from 'react'
import { Provider } from 'react-redux'
import store from '../ReduxImpl/store/index'
import JssFormDisplay from './jssStatefullform'
import { ComponentProps } from '../../types/types'
import './index.scss'

interface PrivacyFormProps extends ComponentProps {
  fields?: any
  history?: any
  params?: any
}

const PrivacyForm: FC<PrivacyFormProps> = ({
  fields,
  history,
  params
  // params: { 'Contact Form': contactForm },
}) => { 
  const _className = useMemo(
    () =>
      `${
        fields.metadata.name.includes('PrivacyRequestForm')
          ? 'PrivacyForm PrivacyForm__white'
          : ''
      }`,
    [fields]
  )

  return (
    <div className={_className}>
      <Provider store={store}>
        <JssFormDisplay
          fields={fields}
          history={history}
          isContact={params?.['Contact Form'] === '1'}
        />
      </Provider>
    </div>
  )
}

export default PrivacyForm
